import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { PURGE } from "redux-persist";
import apiInstance from '../../../../api';

export const getAdminDocuments = createAsyncThunk(
    'financeMonitoringDocuments/getAdminDocuments',
    async (data, { rejectWithValue }) => {
        const api = '/kitchens/getForAdmin?XDEBUG_SESSION_START=MyVSCode';

        try {
            const response = await apiInstance.post(api, JSON.stringify({ data }));

            if (response.data.result) {
                return {
                    kitchens: response.data.data.kitchens,
                    total: response.data.data.pagination.total,
                };
            } else {
                return rejectWithValue('Failed to fetch data');
            }
        } catch (error) {
            console.error('Ошибка при выполнении запроса:', error);
            return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
        }
    }
);

const initialState = {
    getAdminDocumentsStatus: null,
    adminDocuments: [],
    totalAdminDocuments: 0,
    currentAdminDocumentsPage: 1,
};

const deliveryAdminDocumentsSlice = createSlice({
    name: 'deliveryAdminDocuments',
    initialState,
    extraReducers: (builder) => {
        builder
            // fetchOrders
            .addCase(getAdminDocuments.pending, (state) => { state.getAdminDocumentsStatus = 'pending'; })
            .addCase(getAdminDocuments.fulfilled, (state, action) => {
                state.getAdminDocumentsStatus = 'fulfilled';
                state.adminDocuments = action.payload.kitchens;
                state.totalAdminDocuments = action.payload.total;
            })
            .addCase(getAdminDocuments.rejected, (state) => { state.getAdminDocumentsStatus = 'rejected'; })

            // PURGE
            .addCase(PURGE, () => { return initialState; })
    },
    reducers: {
        setCurrentAdminDocumentsPage: (state, action) => {
            state.currentAdminDocumentsPage = action.payload;
        },
        reset: (state) => {
            state.getAdminDocumentsStatus = null;
            state.adminDocuments = [];
            state.totalAdminDocuments = 0;
            state.currentAdminDocumentsPage = 1;
        },
    },
});

export const {
    setCurrentAdminDocumentsPage,
    reset,
} = deliveryAdminDocumentsSlice.actions;

export default deliveryAdminDocumentsSlice.reducer;
